import type { Catalog } from '@smarton-pbx/shared';

/**
 * Words many screens use. Put a text here (not in a part's file) when two
 * parts need it; each English text is translated once.
 */
export const common: Catalog = {
  // Actions (buttons: the infinitive).
  Save: 'Išsaugoti',
  Cancel: 'Atšaukti',
  Delete: 'Ištrinti',
  Close: 'Uždaryti',
  Edit: 'Redaguoti',
  Add: 'Pridėti',
  Remove: 'Pašalinti',
  Back: 'Atgal',
  Next: 'Toliau',
  Done: 'Atlikta',
  Search: 'Ieškoti',
  Call: 'Skambinti',
  Copy: 'Kopijuoti',
  Copied: 'Nukopijuota',
  Export: 'Eksportuoti',
  Undo: 'Atšaukti pakeitimą',
  'Show more': 'Rodyti daugiau',
  'Try again': 'Bandyti dar kartą',
  // Things.
  Name: 'Vardas',
  Email: 'El. paštas',
  Number: 'Numeris',
  Numbers: 'Numeriai',
  Notes: 'Pastabos',
  Language: 'Kalba',
  Region: 'Regionas',
  Role: 'Rolė',
  Optional: 'Neprivaloma',
  None: 'Nėra',
  Nobody: 'Niekas',
  Today: 'Šiandien',
  Yesterday: 'Vakar',
  Loading: 'Įkeliama',
  'Something went wrong. Try again.': 'Kažkas nepavyko. Bandykite dar kartą.',
  // The menu.
  Phone: 'Telefonas',
  Calls: 'Skambučiai',
  Voicemail: 'Balso paštas',
  Contacts: 'Kontaktai',
  Queues: 'Eilės',
  'Call back': 'Perskambinti',
  Pipeline: 'Pardavimų eiga',
  'Call flows': 'Skambučių scenarijai',
  Dashboard: 'Suvestinė',
  Insights: 'Įžvalgos',
  People: 'Darbuotojai',
  Regions: 'Regionai',
  Settings: 'Nustatymai',
  'Audit log': 'Veiksmų žurnalas',
  'Your account': 'Jūsų paskyra',
  Help: 'Pagalba',
  'Sign out': 'Atsijungti',
  Account: 'Paskyra',
  // Roles.
  Admin: 'Administratorius',
  'Region manager': 'Regiono vadovas',
  Agent: 'Agentas',
  // Pipeline stages (shared leadStageNames).
  'To call': 'Skambinti',
  'No answer': 'Neatsiliepė',
  'Not interested': 'Nesudomino',
  Interested: 'Sudomino',
  'Follow up': 'Perskambinti',
  Cancelled: 'Atšaukta',
};
